// extracted by mini-css-extract-plugin
export var container = "key-figure-v2-module--container--5ddb2";
export var description = "key-figure-v2-module--description--04b93";
export var hidden = "key-figure-v2-module--hidden--78c08";
export var value = "key-figure-v2-module--value--bde6d";
export var valueOnly = "key-figure-v2-module--valueOnly--5b2cf";